/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./BaseError";
export * from "./IError";
export * from "./IErrorReport";
export * from "./IntegrationError";
export * from "./ServiceError";
export * from "./ErrorNames";
export * from "./ErrorParsers";
export * from "./errorCodes/grpc";
export * from "./errorCodes/system";
export * from "./errorCodes/postgresql";
